import { useCallback, useEffect } from "react";
import { layerExtent } from "resources/layers";
import { useMapViewActions } from "@evergis/react";

export const useShowLayerOnMap = (spatialReference: number): [(layerName: string) => void] => {
  const [getLayerExtent, { data: extentLayer, loading }] = layerExtent.use();
  const { animateTo } = useMapViewActions();

  useEffect(() => {
    if (extentLayer && !loading) {
      const {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore TODO wrong spcore type
        coordinates: [[xMin, yMin], [xMax, yMax]],
      } = extentLayer;

      if (xMin || yMin || xMax || yMax) {
        animateTo({
          extent: { xMax, xMin, yMax, yMin },
        });
      }
    }
  }, [extentLayer, loading]);

  const showLayerOnMap = useCallback(
    async (layerName: string) => {
      await getLayerExtent({
        input: {
          name: layerName,
          sr: spatialReference,
        },
      });
    },
    [spatialReference],
  );

  return [showLayerOnMap];
};
